<template>
  <div>
    <v-dialog fullscreen hide-overlay  v-model="dialog">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{titleAction}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="cancel()" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <tab-informacion
          ref="informacion"
          @close="close()"
          :edit-external="edit"
          :status="dialog"
          :action="action"
        />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close()" color="primary" small>{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tabInformacion from './tabInformation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'formManager',
  components: {
    tabInformacion
  },
  props: {
    modal: {
      type: Boolean,
      required: true
    },
    edit: {
      type: Boolean,
      required: false,
      default: true
    },
    action: {
      type: String,
      required: false,
      default: 'view'
    }
  },
  data () {
    return {
      tabActive: null
    }
  },
  computed: {
    ...mapState({
      currentAct: state => state.acts.actSelected
    }),
    dialog: {
      get () {
        return this.modal
      },
      set (value) {
        if (!value) {
          this.tabActive = 0
          this.$emit('close')
        }
      }
    },
    titleAction () {
      let title = this.$t('newModel', { field: this.$tc('act') })
      if (this.currentAct && this.currentAct.name) {
        title = this.formatLanguage(this.currentAct.name, '5bd9f3ee7fa5610014fed21e')
      }
      return title
    }
  },
  methods: {
    ...mapActions({
      clearOne: 'acts/setClearOne'
    }),
    cancel () {
      this.close()
    },
    close () {
      this.$refs.informacion.currentStep = 1
      this.dialog = false
      this.$emit('close')
      this.clearOne()
    },
    formatLanguage (text, idLanguage) {
      if (!text) {
        return ' '
      }
      let item = text.find(item => item.langId === idLanguage)
      return item ? item.text : '*'
    }
  }
}
</script>
